const productionBase = process.env.REACT_APP_BASE_URL;;

export default productionBase;
